export default {"src":"/_next/static/media/idea.colour.f1d3d393.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};